<template>
  <div class="mt-0 payment-buttons">
    <!----------------------- Stock Button ----------------------->
    <ShopStock ref="onOpenStock" />
    <b-btn @click="onOpenStock()" class="stock_button">
      <i class="fa fa-edit mr-1" /> Stock
    </b-btn>
    <!----------------------- Draft Button ----------------------->
    <SalesReturn ref="onOpenSaleReturn" />
    <!-- <b-button @click="onOpenSalesReturn()" variant="primary" id="popover-salesreturn-sync" class="mr-3">
            <i class="fa fa-edit mr-1" /> Draft
        </b-button> -->
    <b-popover
      v-if="help_tooltip_visible"
      :show.sync="help_tooltip_visible"
      :placement="'left'"
      variant="danger"
      target="popover-payment-sync"
    >
      <strong>CTRL + {{ keyShortcuts.payment_view }}</strong>
    </b-popover>
    <!----------------------- Quotation Button ----------------------->
    <Qutation ref="onOpenQutation" />
    <b-btn @click="onOpenQutation()" class="quotation_button">
      <i class="fa fa-edit mr-1" /> Quotation
    </b-btn>
    <b-popover
      v-if="help_tooltip_visible"
      :show.sync="help_tooltip_visible"
      :placement="'left'"
      variant="danger"
      target="popover-payment-sync"
    >
      <strong>CTRL + {{ keyShortcuts.payment_view }}</strong>
    </b-popover>
    <!----------------------- Suspend Button ----------------------->
    <!-- <SuspendSales ref="openSuspendSales" />
        <b-btn @click="openSuspendSalesModal()" class="suspend_button">
            <i class="fa fa-pause text-white" aria-hidden="true"></i>Suspend
        </b-btn> -->

    <b-button
      v-if="products.length != 0"
      size="sm"
      class="suspend_button float-right w-100"
      v-b-modal.modal-prevent-closing
    >
      <i class="fa fa-pause text-white mr-1" aria-hidden="true"></i>
      Save as Draft
      <b-modal
        id="modal-prevent-closing"
        ref="modal"
        title="Save as Draft"
        @show="resetModal"
        @hidden="resetModal"
        @ok="handleOk"
        button-size="md"
        ok-title="Yes"
        size="md"
        ok-variant="danger"
        centered
      >
        <form ref="form" @submit.stop.prevent="handleSubmit">
          <b-form-group
            label-for="name-input"
            invalid-feedback="Reason is required"
            :state="draftReasonState"
          >
            <b-form-input
              id="name-input"
              v-model="draftReason"
              :state="draftReasonState"
              required
              placeholder="Enter the reason"
            ></b-form-input>
          </b-form-group>
        </form>
      </b-modal>
    </b-button>
    <!----------------------- Sales Return ----------------------->
    <SuspendSales ref="openSuspendSales" />
    <b-btn @click="onOpenSalesReturn()" class="sales_return_button">
      <i class="fa fa-shopping-basket text-white" aria-hidden="true"></i>Sales
      Return
    </b-btn>

    <!----------------------- Bill Button ----------------------->
    <b-btn
      v-if="!sales_return_visible && sideArea == 'POS'"
      id="popover-bill-sync"
      ref="billsection"
      v-b-toggle.payment-sidebar
      class=""
      size="sm"
      variant="danger"
      @click="setTabNum(1)"
    >
      <i class="fa fa-check mr-1" /> Bill
    </b-btn>
    <!----------------------- Payment Button ----------------------->
    <b-btn
      v-if="
        (!sales_return_visible && sideArea == 'POS') || sideArea == 'QUTATION'
      "
      id="popover-payment-sync"
      ref="paysection"
      v-b-toggle.payment-sidebar
      class="payment_btn"
      size="sm"
      variant="success"
      @click="setTabNum(0)"
    >
      <i class="fa fa-check mr-1" /> Payment
    </b-btn>
    <b-popover
      v-if="help_tooltip_visible"
      :show.sync="help_tooltip_visible"
      :placement="'left'"
      variant="danger"
      target="popover-payment-sync"
    >
      <strong>CTRL + {{ keyShortcuts.payment_view }}</strong>
    </b-popover>
    <!----------------------- Sales Return - Submit Button ----------------------->
    <b-btn
      v-if="sales_return_visible"
      id="popover-payment-sync"
      ref="paysection"
      class="payment_btn"
      size="sm"
      variant="success"
      @click="submitSalesReturn()"
    >
      <i class="fa fa-check mr-1" /> Submit
    </b-btn>
    <!----------------------- Quotation - Submit Button ----------------------->
    <b-btn
      v-if="sideArea == 'QUTATION'"
      id="popover-payment-sync"
      ref="paysection"
      class="payment_btn save_quotation"
      size="sm"
      variant="success"
      :disabled="products.length === 0"
      @click="submitQuotation()"
    >
      <i class="fa fa-check mr-1" /> Save Quotation
    </b-btn>
    <!----------------------- Bill/Payment Sidebar ----------------------->
    <Payment ref="Payment" />

    <!----------------------- Cancel Button ----------------------->
    <b-popover
      v-if="help_tooltip_visible"
      :show.sync="help_tooltip_visible"
      :placement="'top'"
      target="popover-bill-sync"
      variant="danger"
    >
      <strong>CTRL + {{ keyShortcuts.bill_view }}</strong>
    </b-popover>
    <b-button size="sm" class="cancel_button" @click="confirmationPopup">
      <i class="fa fa-window-close mr-1" aria-hidden="true"></i>
      {{ cancelBtnText }}
    </b-button>

    <!----------------------- Total Payable Button----------------------->
    <button
      size="sm"
      class="totalPayable_button float-right w-100"
      v-if="!sales_return_visible"
    >
      Total Payable :{{ (GetTotalAmount + GetServiceTotalAmount) | amount }}
    </button>
    <!----------------------- Total Sale Return Button----------------------->
    <button size="sm" class="totalPayable_button float-right" v-else>
      Total Payable :{{ GetSaleReturnTotalPayableAmount | amount }}
    </button>
    <!-- <b-button size="sm" class="recentTransaction_button float-right w-100">
            Recent Transactions
        </b-button> -->
  </div>
</template>

<script>
import Payment from "@/components/Payment";
import SuspendSales from "@/components/SuspendSales/Index";
import ShortCutKeys from "@/mixins/ShortCutKeys";
import Qutation from "@/components/qutation/index";
import SalesReturn from "@/components/saleReturn/index";
import ShopStock from "@/components/shopStock/index";
import { mapState, mapGetters } from "vuex";

export default {
  data() {
    return {
      draftReason: "",
      draftReasonState: null,
    };
  },
  name: "BottomButtons",
  mixins: [ShortCutKeys],
  components: {
    Payment,
    SuspendSales,
    Qutation,
    SalesReturn,
    ShopStock,
  },
  computed: {
    ...mapState("bill", ["products"]),
    ...mapState("bill", ["customer"]),
    ...mapState("auth", ["help_tooltip_visible"]),
    ...mapState("auth", ["keyShortcuts"]),
    ...mapGetters("bill", [
      "GetTotalAmount",
      "GetDiscountAmount",
      "GetServiceTotalAmount",
    ]),
    ...mapState("dashboard", ["sideArea"]),
    ...mapState("salesReturn", [
      "sales_return_visible",
      "sales_return_products",
      "sales_return_details",
    ]),
    ...mapGetters("salesReturn", {
      GetTotalSaleReturnAmount: "GetTotalAmount",
      GetSaleReturnDiscountAmount: "GetDiscountAmount",
      GetSaleReturnChargeAmount: "GetReturnChargeAmount",
      GetSaleReturnTotalPayableAmount: "GetTotalPayableAmount",
    }),
    totalPayableAmount: function() {
      return (
        this.GetTotalSaleReturnAmount -
        (this.GetSaleReturnDiscountAmount + this.GetSaleReturnChargeAmount)
      );
    },
    cancelBtnText: function() {
      if (this.sideArea == "POS" && !this.sales_return_visible) {
        return "Cancel";
      } else if (this.sales_return_visible) {
        return "Cancel SalesReturn";
      } else if (this.sideArea == "QUTATION") {
        return "Cancel Quotation";
      }
    },
  },
  methods: {
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.draftReasonState = valid;
      return valid;
    },
    resetModal() {
      this.draftReason = "";
      this.draftReasonState = null;
    },
    handleOk(bvModalEvent) {
      bvModalEvent.preventDefault();
      this.handleSubmit();
    },
    handleSubmit() {
      if (!this.checkFormValidity()) {
        return;
      }
      this.$store
        .dispatch("bill/saveSalesAsDraft", {
          comment: this.draftReason,
          data: this.products,
        })
        .then((res) => {
          this.showToast("Sale Successfully Saved in Draft", "success");
        });
      this.cancelBill();
      this.$nextTick(() => {
        this.$bvModal.hide("modal-prevent-closing");
      });
    },
    setTabNum(value) {
      this.$store.commit("bill/SET_PRINT_DATA_STATUS", false);
      this.$store.commit("bill/SET_CUSTOMER_DISCOUNT_AMOUNT", 0);
      this.$refs.Payment.setTabNum(value);
      // if (value == 0) {
      this.$refs.Payment.setAmount(
        this.GetTotalAmount + this.GetServiceTotalAmount
      );
      this.$refs.Payment.commitPayments();
      // }
    },
    openSuspendSalesModal() {
      this.$refs.openSuspendSales.showModal();
    },
    onOpenSalesReturn() {
      this.$refs.onOpenSaleReturn.showModal();
    },
    onOpenQutation() {
      this.$refs.onOpenQutation.showModal();
    },
    onOpenStock() {
      this.$refs.onOpenStock.showModal();
    },
    cancelBill() {
      this.$store.dispatch("bill/cancelBill").then((res) => {
        this.showToast("Bill Cancelled", "success");
      });
    },
    showToast(message, variant = null) {
      this.$bvToast.toast(message, {
        title: "Message",
        variant,
        solid: true,
      });
    },
    // Sales Return functions
    submitSalesReturn() {
      this.$nextTick(() => {
        this.$bvModal.hide("modal-prevent-closing");
      });
    },

    confirmationPopup() {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to cancel everything.", {
          title: "Please Confirm",
          size: "md",
          buttonSize: "md",
          okVariant: "danger",
          okTitle: "Yes",
          cancelTitle: "No",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (this.sales_return_visible) {
            this.$store.dispatch("salesReturn/setVisibleSalesReturn", false);
          } else {
            if (value) this.cancelBill();
            if (this.sideArea == "QUTATION") {
              this.$store.commit("dashboard/SET_SIDE_AREA", "POS");
              this.$store.commit("quotation/SET_ISSUBMITTEDSALE", false);
            }
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },

    setTabNum(value) {
      this.$store.commit("bill/SET_CUSTOMER_DISCOUNT_AMOUNT", 0);
      this.$refs.Payment.setTabNum(value);
      // if (value == 0) {
      this.$refs.Payment.setAmount(
        this.GetTotalAmount + this.GetServiceTotalAmount
      );
      this.$refs.Payment.commitPayments();
      // }
    },
    openSuspendSalesModal() {
      this.$refs.openSuspendSales.showModal();
    },
    onOpenSalesReturn() {
      this.$refs.onOpenSaleReturn.showModal();
    },
    onOpenQutation() {
      this.$refs.onOpenQutation.showModal();
    },
    onOpenStock() {
      this.$refs.onOpenStock.showModal();
    },
    cancelBill() {
      this.$store.dispatch("bill/cancelBill").then((res) => {
        this.showToast("Bill Cancelled", "success");
      });
    },
    showToast(message, variant = null) {
      this.$bvToast.toast(message, {
        title: "Message",
        variant,
        solid: true,
      });
    },
    // Sales Return functions
    submitSalesReturn() {
      var Barcode = String(new Date().getTime());

      var SalesReturnProductsData = this.sales_return_products.map((item) => {
        return {
          product_id: item.product.id,
          batch_id: item.batch.id,
          unit_id: item.unit.id,
          quantity: item.quantity,
          amount: item.amount,
          return_charge: item.return_charge ? item.return_charge : 0,
        };
      });

      this.$store
        .dispatch("salesReturn/submitSalesReturn", {
          sale_id: this.sales_return_details.id,
          barcode: Barcode,
          items: SalesReturnProductsData,
        })
        .then((res) => {
          this.showToast("Sales Returned Successfully", "success");
          this.$store.dispatch("salesReturn/setVisibleSalesReturn", false);
          this.$store.dispatch("shops/fetchCashflowData");
        })
        .catch((err) => {});
    },
    submitQuotation() {
      this.$store
        .dispatch("quotation/onCreateQuotation", {
          items: this.products,
          customer: this.customer,
        })
        .then((res) => {
          if (res.status == 200) {
            // this.$store.dispatch('bill/cancelBill');
            this.showToast("Quotation Create Success", "success");
          } else this.showToast("Quotation Create Failed", "danger");
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.payment_btn {
  padding: 2px 20px;
}
.save_quotation {
  width: 170px !important;
}
.cancel_button {
  width: 170px !important;
}
.totalPayable_button {
  width: 190px !important;
  color: white !important;
  border-radius: 4px;
}
</style>
